// extracted by mini-css-extract-plugin
export default {"AppWhatWeOffer":"AppWhatWeOffer_AppWhatWeOffer__lYACf","AppWhatWeOffer__wrap":"AppWhatWeOffer_AppWhatWeOffer__wrap__S32Qb"};